/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type BatchSize = string | number;

export type LearningRateMultiplier = string | number;

export type NEpochs = string | number;

export type SupervisedHyperparameters = {
  /**
   * Number of examples in each batch
   */
  batchSize?: string | number | null | undefined;
  /**
   * Scaling factor for learning rate
   */
  learningRateMultiplier?: string | number | null | undefined;
  /**
   * Number of epochs to train for
   */
  nEpochs?: string | number | null | undefined;
};

/** @internal */
export const BatchSize$inboundSchema: z.ZodType<
  BatchSize,
  z.ZodTypeDef,
  unknown
> = z.union([z.string(), z.number().int()]);
/** @internal */
export type BatchSize$Outbound = string | number;

/** @internal */
export const BatchSize$outboundSchema: z.ZodType<
  BatchSize$Outbound,
  z.ZodTypeDef,
  BatchSize
> = z.union([z.string(), z.number().int()]);

export function batchSizeToJSON(batchSize: BatchSize): string {
  return JSON.stringify(BatchSize$outboundSchema.parse(batchSize));
}
export function batchSizeFromJSON(
  jsonString: string,
): SafeParseResult<BatchSize, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BatchSize$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BatchSize' from JSON`,
  );
}

/** @internal */
export const LearningRateMultiplier$inboundSchema: z.ZodType<
  LearningRateMultiplier,
  z.ZodTypeDef,
  unknown
> = z.union([z.string(), z.number()]);
/** @internal */
export type LearningRateMultiplier$Outbound = string | number;

/** @internal */
export const LearningRateMultiplier$outboundSchema: z.ZodType<
  LearningRateMultiplier$Outbound,
  z.ZodTypeDef,
  LearningRateMultiplier
> = z.union([z.string(), z.number()]);

export function learningRateMultiplierToJSON(
  learningRateMultiplier: LearningRateMultiplier,
): string {
  return JSON.stringify(
    LearningRateMultiplier$outboundSchema.parse(learningRateMultiplier),
  );
}
export function learningRateMultiplierFromJSON(
  jsonString: string,
): SafeParseResult<LearningRateMultiplier, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LearningRateMultiplier$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LearningRateMultiplier' from JSON`,
  );
}

/** @internal */
export const NEpochs$inboundSchema: z.ZodType<NEpochs, z.ZodTypeDef, unknown> =
  z.union([z.string(), z.number().int()]);
/** @internal */
export type NEpochs$Outbound = string | number;

/** @internal */
export const NEpochs$outboundSchema: z.ZodType<
  NEpochs$Outbound,
  z.ZodTypeDef,
  NEpochs
> = z.union([z.string(), z.number().int()]);

export function nEpochsToJSON(nEpochs: NEpochs): string {
  return JSON.stringify(NEpochs$outboundSchema.parse(nEpochs));
}
export function nEpochsFromJSON(
  jsonString: string,
): SafeParseResult<NEpochs, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => NEpochs$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'NEpochs' from JSON`,
  );
}

/** @internal */
export const SupervisedHyperparameters$inboundSchema: z.ZodType<
  SupervisedHyperparameters,
  z.ZodTypeDef,
  unknown
> = z.object({
  batch_size: z.nullable(z.union([z.string(), z.number().int()])).optional(),
  learning_rate_multiplier: z.nullable(z.union([z.string(), z.number()]))
    .optional(),
  n_epochs: z.nullable(z.union([z.string(), z.number().int()])).optional(),
}).transform((v) => {
  return remap$(v, {
    "batch_size": "batchSize",
    "learning_rate_multiplier": "learningRateMultiplier",
    "n_epochs": "nEpochs",
  });
});
/** @internal */
export type SupervisedHyperparameters$Outbound = {
  batch_size?: string | number | null | undefined;
  learning_rate_multiplier?: string | number | null | undefined;
  n_epochs?: string | number | null | undefined;
};

/** @internal */
export const SupervisedHyperparameters$outboundSchema: z.ZodType<
  SupervisedHyperparameters$Outbound,
  z.ZodTypeDef,
  SupervisedHyperparameters
> = z.object({
  batchSize: z.nullable(z.union([z.string(), z.number().int()])).optional(),
  learningRateMultiplier: z.nullable(z.union([z.string(), z.number()]))
    .optional(),
  nEpochs: z.nullable(z.union([z.string(), z.number().int()])).optional(),
}).transform((v) => {
  return remap$(v, {
    batchSize: "batch_size",
    learningRateMultiplier: "learning_rate_multiplier",
    nEpochs: "n_epochs",
  });
});

export function supervisedHyperparametersToJSON(
  supervisedHyperparameters: SupervisedHyperparameters,
): string {
  return JSON.stringify(
    SupervisedHyperparameters$outboundSchema.parse(supervisedHyperparameters),
  );
}
export function supervisedHyperparametersFromJSON(
  jsonString: string,
): SafeParseResult<SupervisedHyperparameters, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SupervisedHyperparameters$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SupervisedHyperparameters' from JSON`,
  );
}
